<template>
  <div>
    <b-button
        style="background-color: #185E8B"
        class="mt-4"
        @click="clickEnter()"
        size="lg"
    >{{$t('Click to apply')}}
    </b-button>
    <b-modal
        hide-footer
        v-model="modalActive"
        id="modal-center"
        centered
        :title="$t('message.Enter')">
      <div
          v-for="type in phoneNumber"
          :key="type">
        <p>{{$t('message.Phone_number')}}</p>
      <b-form-input
          :id="`type-${type}`"
          :type="type"
          placeholder="+998(__)___-__-__"
      >
      </b-form-input>
      </div>
      <div
          class="mt-2"
          v-for="val in password"
          :key="val">
        <p>{{$t('message.Password')}}</p>
      <b-form-input
          :id="`type-${val}`"
          :val="val">
      </b-form-input>
      </div>
      <div class="justify-content-end d-flex mt-4">
        <b-button
            class="btn"
            @click="handleClick"
            variant="danger"
            size="md"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            variant="success"
            size="md"
            @click="clickEnter()"
        >{{$t('message.Enter')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalForm",
  data(){
    return{
      modalActive: false,
      phoneNumber:[
          'number',
      ],
      password:[
          'text'
      ]
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    clickEnter(){
    this.$router.push({name:'fvacancyindex' })
    }
  }
}
</script>

<style scoped>
.btn{
  margin-right: 10px;
  border-radius: 15px;
}
</style>
